import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import { Button, FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, Stack } from "@mui/material";
import React, { FormEvent, ReactNode, useRef } from "react";
import "./Login.css";

import { useGoogleLogin } from "@react-oauth/google";

import Google from "../../static/google.svg";

import { Link } from "react-router-dom";
import { LoginMethod } from "../../enums/enums";

export default function LoginForm(props: {
  children: ReactNode;
  callback: CallableFunction;
  google: CallableFunction;
}) {
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => event.preventDefault();

  const usernameRef = useRef<HTMLInputElement>(null);
  const passwordRef = useRef<HTMLInputElement>(null);
  const [showPassword, setShowPassword] = React.useState(false);

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    props.callback({
      username: usernameRef.current?.value ?? "",
      password: passwordRef.current?.value ?? "",
    });
  };

  const login = useGoogleLogin({
    onSuccess: (codeResponse) => {
      props.google(codeResponse, LoginMethod.GOOGLE);
    },
    flow: "auth-code",
  });

  return (
    <Stack component={"form"} sx={{ flexGrow: 1 }} spacing={2} onSubmit={handleSubmit}>
      <FormControl fullWidth={true}>
        <InputLabel htmlFor="outlined-basic">Username</InputLabel>
        <OutlinedInput
          id="outlined-basic"
          inputRef={usernameRef}
          placeholder="Username"
          label="Username"
          type="email"
          name="email"
          autoComplete="username"
          required
        />
      </FormControl>
      <FormControl fullWidth={true}>
        <InputLabel htmlFor="outlined-adornment-password">Password</InputLabel>
        <OutlinedInput
          id="outlined-adornment-password"
          inputRef={passwordRef}
          placeholder="Password"
          label="Password"
          name="password"
          autoComplete="current-password"
          required
          type={showPassword ? "text" : "password"}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                aria-label="toggle password visibility"
                onClick={handleClickShowPassword}
                onMouseDown={handleMouseDownPassword}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          }
        />
      </FormControl>
      <Button variant="contained" type="submit">
        Login
      </Button>
      <Button component={Link} to="/reset">
        Forgot Password
      </Button>

      <Button onClick={login}>
        <img src={Google} className="icon-sm" alt="Sign in with Google" />
      </Button>

      {props.children}
    </Stack>
  );
}
